// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Replace with your Supabase project URL and anon/public key
const supabaseUrl = 'https://wwwikvfwquvafkoopemw.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3d2lrdmZ3cXV2YWZrb29wZW13Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0ODgzOTMsImV4cCI6MjA3MjA2NDM5M30.XWFa9XiYnMcBP-sHWMAzsXO53mE2P7hk8Xh-KnDwt88';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
